import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {Authority} from '../models/authority';

export interface AuthService {
    authorities$: Observable<Authority[]>;
    initialize(): Promise<void>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthServiceImpl implements AuthService {
    private http = inject(HttpClient);

    private authoritiesSubject = new BehaviorSubject<Authority[]>([]);
    authorities$: Observable<Authority[]> = this.authoritiesSubject.asObservable();

    async initialize(): Promise<void> {
        await this.loadAuthorities()
    }

    private async loadAuthorities(): Promise<void> {
        try {
            const authorities = await this.getAuthorities().toPromise();
            if (Array.isArray(authorities) && authorities.every(it => typeof it === 'string')) {
                this.authoritiesSubject.next(authorities);
            } else {
                console.warn('Invalid authorities returned by server', authorities);
            }
        } catch (error) {
            console.warn('Unable to initialize user roles', error);
        }
    }

    private getAuthorities(): Observable<Authority[]> {
        return this.http.get<Authority[]>('/api/v1/auth/authorities');
    }
}
